import { useEffect, useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useLocation } from 'react-router-dom';
import { Container, Nav, Navbar } from 'react-bootstrap';
import useNavbarSidebar from './useNavbarSidebar';
import { Select, Avatar, Dropdown } from 'antd';
import useSidebar from '../sidebar/useSidebar';
import { UserOutlined, LogoutOutlined, DownOutlined } from '@ant-design/icons';

const NavbarSidebar = () => {
    const { getCurrentRealUser, logout} = useAuth()
    const {LogoutFunction} = useSidebar()
    const [user, setUser] = useState()
    const {
        getAllUsers,
        getAllUsersAdmin,
        getAllUsersSpmoHandle,
        employeeSelect,
        selectedUser,
        getUser,
        switchUser,
        loading
    } = useNavbarSidebar()
    const location = useLocation();
    const [activeNavLink, setActiveNavLink] = useState('');

    useEffect(() => {
        setActiveNavLink(location.pathname);
    }, [location]);

    useEffect(() => {
        let data = getCurrentRealUser()
        if (data) {
            if (data.Role) {
                if (data.Role.includes('superadmin')) {
                    getAllUsers()
                } else if(data.Role.includes('admin')){
                    getAllUsersAdmin()
                }else if(data.Role.includes('spmo')){
                    getAllUsersSpmoHandle(data.ID)
                }
            }
            setUser(data)
            getUser(data.SwitchUser.ID)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const userMenuItems = [
        {
            key: 'profile',
            icon: <UserOutlined />,
            label: <span style={{ fontWeight: 500 }}>{user?.Name}</span>,
        },
        {
            type: 'divider',
        },
        {
            key: 'logout',
            icon: <LogoutOutlined />,
            label: 'Logout',
            danger: true,
            onClick: () => {
                // Create a fake event object for compatibility with LogoutFunction
                const fakeEvent = { preventDefault: () => {} };
                LogoutFunction(fakeEvent, logout);
            },
        },
    ];
    
    return (
        <Navbar expand="lg" className="bg-body-tertiary color-nav" sticky="top" style={{ padding: '0.5rem 0', boxShadow: '0 2px 8px rgba(0,0,0,0.15)', background: 'linear-gradient(to bottom right, #02B4CC 0%, #0284C7 100%)' }}>
            <Container fluid style={{ paddingLeft: '16px', paddingRight: '16px' }}>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto align-items-center">
                        {
                            user && user.Role && (user.Role.includes('superadmin') || user.Role.includes('admin') ||user.Role.includes('spmo')) ?
                            <div className='d-flex align-items-center' style={{ background: 'white', padding: '5px 15px', borderRadius: '30px' }}>
                                <span style={{color:"#0284C7", marginRight: "10px", fontSize: "0.9rem", fontWeight: "600"}}>Switch User:</span>
                                <Select
                                    allowClear     
                                    showSearch={true}   
                                    style={{width:"200px"}}
                                    options={employeeSelect}
                                    value={selectedUser}
                                    onChange={(value) => switchUser(value, user)}
                                    placeholder="Select user"
                                    bordered={false}
                                    loading={loading}
                                    notFoundContent={loading ? 'Loading...' : 'No data'}
                                    popupClassName="navbar-select-dropdown"
                                    getPopupContainer={(trigger) => trigger.parentNode}
                                />
                            </div>:
                            <></>
                        }
                    </Nav>
                    <Nav className="align-items-center gap-3">
                        <div className="d-flex align-items-center">
                            <img 
                                src="/logo_gowin.png" 
                                alt="Gowin Logo" 
                                style={{ 
                                    height: '32px',
                                    width: 'auto'
                                }}
                            />
                        </div>
                        <div>
                            <Dropdown menu={{ items: userMenuItems }} trigger={['click']} placement="bottomRight">
                                <div className="d-flex align-items-center cursor-pointer user-profile-trigger" style={{ cursor: 'pointer', background: 'white', padding: '5px 12px', borderRadius: '30px' }}>
                                    <Avatar icon={<UserOutlined />} src={user?.ProfileImage} style={{ background: 'linear-gradient(to bottom right, #02B4CC 0%, #0284C7 100%)', color: 'white' }} />
                                    <span className="ms-2 d-none d-md-block" style={{ fontWeight: 600, color: '#0284C7' }}>{user?.Name}</span>
                                    <DownOutlined className="ms-2" style={{ fontSize: '10px', color: '#0284C7' }} />
                                </div>
                            </Dropdown>
                        </div>
                    </Nav>
                </Navbar.Collapse>
            </Container>
            <style>
                {`
                    .nav-link-custom {
                        text-decoration: none;
                        color: rgba(255,255,255,0.8);
                        transition: all 0.3s;
                    }
                    .nav-link-custom:hover {
                        color: white;
                    }
                    .active-nav-item {
                        background-color: rgba(255,255,255,0.2);
                        color: white;
                        font-weight: 500;
                    }
                    .nav-icon {
                        font-size: 1.2rem;
                    }
                `}
            </style>
      </Navbar>
    )
}

export default NavbarSidebar;
